// extracted by mini-css-extract-plugin
export default {"employee-container":"MidMonthPay_employee-container__oq1qm","mid-month-header":"MidMonthPay_mid-month-header__yAcvJ"};